<template>
  <svg viewBox="0 0 48 48">
    <rect
      width="19"
      height="19"
      x="2"
      y="2"
      fill="#F25022"
    />
    <rect
      width="19"
      height="19"
      x="24"
      y="2"
      fill="#7FBA00"
    />
    <rect
      width="19"
      height="19"
      x="2"
      y="24"
      fill="#00A4EF"
    />
    <rect
      width="19"
      height="19"
      x="24"
      y="24"
      fill="#FFB900"
    />
  </svg>
</template>


